import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/primary_white_logo.svg';

const NAV_LINKS = [
  { to: '/investor-portal', label: 'Investor Portal' },
  { to: '/privacy', label: 'Privacy & Cookie Policy' },
  { to: '/terms', label: 'Terms and Conditions' },
  { to: '/contact', label: 'Contact' },
];

/**
 * Site header. `size` controls the logo: "large" on the home page,
 * "small" everywhere else. On mobile the nav collapses behind a
 * burger toggle.
 */
export default function Header({ size = 'large' }) {
  const [open, setOpen] = useState(false);
  const headerRef = useRef(null);
  const location = useLocation();

  // Close the menu whenever the route changes
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Close on click outside or Escape
  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (headerRef.current && !headerRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <header className={`site-header site-header--${size}`} ref={headerRef}>
      <Link to="/" className="site-logo" aria-label="Erebus Capital home">
        <Logo />
      </Link>

      <nav className={`site-nav${open ? ' site-nav--open' : ''}`}>
        {NAV_LINKS.map(({ to, label }) => (
          <Link key={to} to={to}>
            {label}
          </Link>
        ))}
      </nav>

      <button
        type="button"
        className={`nav-toggle${open ? ' nav-toggle--open' : ''}`}
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span />
        <span />
        <span />
      </button>
    </header>
  );
}
